<template>
  <div v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <el-row :gutter="10">
      <!-- 標籤列表 -->
      <el-col :span="14">
        <h3 style="margin: 0; background-color: #666; padding: 3px; color: #fff; font-weight: 600;">標籤列表</h3>
        <el-select v-model="radio1" placeholder="請選擇" style="width: 100%;">
          <el-option v-for="item in ['生日標籤', '特定標籤']"
            size="small"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <el-table :data="getList(TagList)" empty-text="目前無分眾標籤" key="table2" border :height="380">
          <el-table-column prop="type"
            label="標籤名稱">
            <template slot-scope="scope">
              <i class="el-icon-price-tag"></i>
              <span style="margin-left: 10px;">{{ scope.row ? scope.row[0]: 'Unknown' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type"
            :width="120"
            label="分眾人數">
            <template slot-scope="scope">
              <span style="margin-left: 10px;">{{ scope.row ? scope.row[1].totalRecipients : 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type"
            :width="160"
            label="名單">
            <template slot-scope="scope">
              <el-button @click="showList(scope.row)" size="mini" type="info" :disabled="scope.row[1].totalRecipients < 1">查看</el-button>
              <el-button size="mini" type="danger" @click="showRemoveDia(scope.row)">刪除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="6" style="text-align: left;">
            <div v-if="getList(TagList).length >= limitTag" style="color: #f24;">
              標籤數：{{ getList(TagList).length }} / {{ limitTag ? limitTag : '-' }}
            </div>
            <div v-else>
              標籤數：{{ getList(TagList).length }} / {{ limitTag ? limitTag : '-' }}
            </div>
          </el-col>
          <el-col :span="18">
            <div style="margin-top: 10px; text-align: right;">
              <el-button type="info" @click="refresh">刷新
                <i class="el-icon-refresh el-icon--right"></i>
              </el-button>
              <el-button type="primary" @click="createBatch">批次上標籤</el-button>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <!-- 新增刪除 -->
      <el-col :span="10">
        <h3 style="margin: 0; background-color: #666; padding: 3px; color: #fff; font-weight: 600;">查詢用戶標籤</h3>
        <el-row style="margin-top: 20px;" :gutter="5">
          <el-col :span="16">
            <el-input v-model="userDetail.phone" placeholder="請輸入用戶電話"></el-input>
          </el-col>
          <el-col :span="8">
            <el-button :loading="isLoading" icon="el-icon-search" type="primary" @click="searchTag">查詢</el-button>
          </el-col>
        </el-row>
        <div v-if="showDetail" style="text-align: left; margin-top: 20px; font-size: 15px;">
          用戶名稱: <span style="color: #409EFF; font-weight: 500;">{{ userDetail.name ? userDetail.name : 'Unknown' }}</span><hr style="border: 1px solid #eee;">
          用戶標籤:
          <div style="margin-top: 15px;">
            <div v-for="(tag, index) in userDetail.tags" :key="index + 't'" class="blue_btn" style="margin-bottom: 10px;" @click="checkdelete(tag, index)">
              <i class="el-icon-price-tag"></i>
              {{ tag }}
            </div>
          </div><hr style="border: 1px solid #eee;">
          新增標籤:
          <div style="margin-top: 10px;">
            <el-row :gutter="10">
              <el-col :span="17">
                <el-select v-model="addTag"
                  style="width: 100%;"
                  filterable
                  no-data-text="無資料"
                  allow-create
                  placeholder="請輸入標籤"
                  default-first-option>
                  <el-option v-for="tag in userTagsBox.filter(el => userDetail.tags.indexOf(el) === -1 && el !== '無')"
                    :key="tag"
                    :label="tag"
                    :value="tag">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="7">
                <el-button type="primary" @click="addUserTag">新增</el-button>
              </el-col> 
            </el-row>
            <div v-if="!createAvalible" style="color: #f24;">{{ alertMessage }}</div>
            <div style="margin-top: 5px; margin-left: 2px;">
              <el-checkbox-group v-model="bindServ">
                <el-checkbox v-if="service === 'FB'" label="FB">同時新增到 FB 分眾</el-checkbox>
                <el-checkbox v-if="service === 'LINE'" label="LINE">同時新增到 LINE 分眾</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <mu-dialog :open="showDeleteDia" title="確認訊息" width="500">
          <div>確定要將標籤<span style="font-weight: 500; color: #409EFF;"> {{ deletedTag }} </span>從用戶移除嗎 ?</div>
          <el-checkbox v-if="service === 'FB'" v-model="sync" label="FB">同時刪除 FB 分眾</el-checkbox>
          <el-checkbox v-if="service === 'LINE'" v-model="sync" label="LINE">同時刪除 LINE 分眾</el-checkbox>
          <mu-button slot="actions" flat color="primary" @click="showDeleteDia = false">返回</mu-button>
          <mu-button slot="actions" color="primary" @click="confirmRemove">確認</mu-button>
        </mu-dialog>
        <mu-dialog title="系統通知" width="500" :open="unknownUser" @close="unknownUser = false">
          此電話尚未註冊成會員哦!
        </mu-dialog>
      </el-col>
    </el-row>
    <!-- 批量上 TAG -->
    <mu-dialog title="批量上標籤" :open="batchDia" width="650" @close="batchDia = false">
      <div v-if="tagPage === '0'">
        <mu-select v-if="tagStatus === 'select'" label="選擇標籤名稱" v-model="tagName">
          <mu-option v-for="option in tagNames" :key="option" :label="option" :value="option"></mu-option>
        </mu-select>
        <mu-text-field v-if="tagStatus === 'create'" v-model.trim="createdTag" placeholder="請輸入標籤名稱"></mu-text-field>
        <mu-button v-if="tagStatus === 'select'" style="margin-left: 15px; transform: translateY(-3px);" color="grey" @click="tagStatus = 'create'">創建</mu-button>
        <mu-button v-if="tagStatus === 'create'" style="margin-left: 15px; transform: translateY(-3px);" color="success" @click="addToTags">加入</mu-button>
      </div>
      <div v-if="tagPage === '1'">
        可一次將多位會員加上同一標籤（每次上限 <b>1000</b> 人），需上傳格式 <b>.xlsx</b> 的用戶資料，格式如下（欄位名稱固定為 <b>Phone</b>）：
        <img src="https://i.imgur.com/P1oqHaX.png" width="70%" style="margin-top: 10px;"/>
      </div>
      <div v-if="tagPage === '2'">
        <div>
          <el-button type="info" @click="export2Excel">下載範例檔</el-button>
          <label style="padding: 10px 20px; font-size: 14px; border-radius: 4px; cursor: pointer; background-color: #409EFF; color: #fff; margin-left: 10px;">
            <input style="display:none;" type="file" @change="transformFile">上傳檔案
          </label>
        </div>
        <div style="margin-top: 5px;">
          <el-table :data="sheetUsers"
            empty-text="暫無數據"
            height="300"
            style="width: 100%">
            <el-table-column
              type="index"
              width="80">
            </el-table-column>
            <el-table-column
              prop="Phone"
              label="電話">
            </el-table-column>
          </el-table>
          名單人數：<span style="color: #f24;">{{ sheetUsers.length }}</span>
        </div>
      </div>
      <!-- 進度條 -->
      <mu-dialog :open="progressBar" width="650">
        <mu-linear-progress></mu-linear-progress>
      </mu-dialog>
      <!-- 確認名單 -->
      <mu-dialog :open="confirmDia" width="650" @close="confirmDia = false">
        確定要將這 <span style="color: #f24;">{{ sheetUsers.length }}</span> 位用戶加入分眾標籤 <span style="color: #f24;">{{ tagName }}</span> 嗎？
        <el-checkbox-group v-model="bindServ">
          <el-checkbox v-if="service === 'FB'" label="FB">同時新增到 FB 分眾</el-checkbox>
          <el-checkbox v-if="service === 'LINE'" label="LINE">同時新增到 LINE 分眾</el-checkbox>
        </el-checkbox-group>
        <mu-button slot="actions" color="primary" @click="addUserTags">確認</mu-button>
      </mu-dialog>
      <mu-button v-if="tagPage === '0'" slot="actions" color="primary" @click="tagPage = '1'">下一頁</mu-button>
      <mu-button v-if="tagPage === '1'" slot="actions" color="primary" @click="tagPage = '0'" flat>上一頁</mu-button>
      <mu-button v-if="tagPage === '1'" slot="actions" color="primary" @click="tagPage = '2'">確認</mu-button>
      <mu-button v-if="tagPage === '2'" slot="actions" color="primary" @click="tagPage = '1'" flat>上一頁</mu-button>
      <mu-button v-if="tagPage === '2'" slot="actions" color="primary" @click="confirmDia = true" :disabled="sheetUsers.length < 1">匯入名單</mu-button>
    </mu-dialog>
    <mu-dialog title="分眾會員名單" :open="showTagUser" width="650" @close="showTagUser = false">
      <el-table :data="TagUser"
        height="calc(100vh - 400px)"
        style="width: 100%">
        <el-table-column type="index"
          width="80">
        </el-table-column>
        <el-table-column prop="name"
          label="會員姓名">
          <template slot-scope="scope">
            <span>{{ scope.row[1].Name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name"
          label="會員電話">
          <template slot-scope="scope">
            <span>{{ scope.row[1].Phone }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name"
          width="130"
          label="操作">
          <template slot-scope="scope">
            <el-button type="danger" @click="checkRemove(scope.row)" size="mini">刪除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button v-if="isWhite" style="margin-top: 10px; width: 100%;" type="primary" @click="exportToExcel">匯出名單</el-button>
      <!-- <mu-button slot="actions" color="primary" @click="exportToExcel()">匯出名單</mu-button> -->
    </mu-dialog>
    <!-- 進度條 -->
    <mu-dialog :open="tagRemoveDia" width="650">
      <div>請再次確定是否要刪除該分眾？此動作無法復原</div>
      <mu-button slot="actions" color="primary" @click="tagRemoveDia = false" flat>返回</mu-button>
      <mu-button slot="actions" color="primary" @click="sendRemoveTag">確定</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import XLSX from 'xlsx';
import { mapActions, mapGetters } from 'vuex';


export default {
  name: 'tag',
  data() {
    return {
      batchDia: false,
      isLoading: false,
      showDetail: false,
      showDeleteDia: false,
      progressBar: false,
      unknownUser: false,
      confirmDia: false,
      showTagUser: false,
      pageLoading: false,
      tagRemoveDia: false,
      deletedIndex: 0,
      createAvalible: true,
      alertMessage: '',
      tagPage: '0',
      tagName: '',
      deleteTag: '',
      deletedTag: '',
      addTag: '',
      radio1: '特定標籤',
      sync: false,
      usableTag: [],
      exportsUser: [],
      sheetUsers: [],
      bindServ: [],
      tagNames: [],
      createdTag: '',
      tagStatus: 'select',
      userDetail: {
        phone: '',
        name: '',
        tags: [],
        token: ''
      },
      sheetData: [
        { 'Phone':'0981070946' },
        { 'Phone':'0987747267' },
        { 'Phone':'0926724606' },
      ],
      TagUser: [
        ['12345', { Name: '載入中...', Phone: '載入中...' }]
      ],
    }
  },
  props: ['TagList', 'service', 'auth', 'userTagsBox', 'limitTag'],
  // mounted() {
  //   this.usableTag = this.TagList.filter(el => el[0].indexOf('ELS_BIRTH') === -1);
  //   console.log(this.usableTag);
  // },
  computed: {
    isWhite() {
      if (localStorage.getItem('UserID') === 'VRLLI1TLgPhYBDw327IjSc74Z7k1' || localStorage.getItem('UserID') === 'ilHLQLQgQlYGo8jSZ8aGb2AzVlV2') {
        return true;
      }
      return false;
    }
  },
  mounted() {
    console.log(this.limitTag);
  },
  methods: {
    ...mapActions({
      getAllTags           : 'getAllTags',
      addToTag             : 'addUserTag',
      removeTags           : 'removeTags',
      createTags           : 'createTags',
      getTagUser           : 'getTagUser',
      refreshTagNum        : 'refreshTagNum',
      removeTagFromAccount : 'removeTagFromAccount',
    }),
    showFlassMessage(message, time) {
      this.$notify({
        title: message,
        type: 'success'
      });
    },
    addToTags() {
      if (this.createdTag && this.tagNames.indexOf(this.createdTag) === -1) {
        this.tagNames.push(this.createdTag);
        this.tagName = this.createdTag;
      }
      this.tagStatus = 'select';
    },
    createBatch() {
      this.batchDia = true;
      this.tagPage = '0';
      this.tagNames = this.TagList.map(el => el[0]);
    },
    getList(list) {
      if (this.radio1 === '生日標籤') {
        return list.filter(el => el[0].indexOf('ELS_BIRTH') !== -1);
      }
      else {
        return list.filter(el => el[0].indexOf('ELS_BIRTH') === -1);
      }
    },
    refresh() {
      this.$emit('getTags', '');
    },
    showRemoveDia(row) {
      this.tagRemoveDia = true;
      this.deleteTag = row[0];
    },
    sendRemoveTag() {
      this.tagRemoveDia = false;
      this.pageLoading  = true;
      this.removeTagFromAccount({ service: this.service, auth: this.auth, tag: this.deleteTag })
        .then(() => {
          this.pageLoading = false;
          this.refresh();
        });
    },
    searchTag() {
      this.isLoading = true;
      this.getAllTags({ service: this.service, auth: this.auth, phone: this.userDetail.phone.trim() })
        .then((res) => {
          this.isLoading = false;
          const _userDetail = res.UserDetail;
          if (_userDetail) {
            this.showDetail       = true;
            this.userDetail.name  = _userDetail.Name;
            this.userDetail.token = _userDetail.Token;
            this.userDetail.tags  = _userDetail.Tags;
          }
          else {
            this.showDetail       = false;
            this.unknownUser      = true;
            this.userDetail.phone = '';
            this.userDetail.name  = '';
            this.userDetail.token = '';
            this.userDetail.tags  = [];
          }
        })
    },
    checkdelete(tag, index) {
      this.deletedIndex = index;
      this.deletedTag = tag;
      this.showDeleteDia = true;
    },
    addUserTag() {
      if (!this.addTag && this.addTag === '') { return }
      if ((this.TagList.length > 0) && this.TagList.map(el => el[0]).indexOf(this.addTag) === -1 && this.limitTag && (this.limitTag <= this.getList(this.TagList).length)) {
        this.createAvalible = false;
        this.alertMessage = '已達標籤數量上限';
      }
      else {
        this.createAvalible = true;
        this.pageLoading = true;
        this.addToTag({ service: this.service, auth: this.auth, phone: this.userDetail.phone, addTag: this.addTag, bindServ: (this.bindServ !== [] && this.bindServ.length >= 1) ? this.bindServ : null })
          .then(() => {
            this.bindServ = [];
            this.userDetail.tags.push(this.addTag);
            this.pageLoading = false;
            this.refresh();
            this.showFlassMessage('新增用戶標籤成功', 1000);
          })
      }
    },
    confirmRemove() {
      this.showTagUser   = false;
      this.showDeleteDia = false;
      this.pageLoading   = true;
      this.removeTags({ service: this.service, auth: this.auth, token: this.userDetail.token, deletedTag: this.deletedTag, sync: this.sync })
        .then(() => {
          this.userDetail.tags.splice(this.deletedIndex, 1);
          this.pageLoading = false;
          this.showFlassMessage('已刪除用戶標籤', 1000);
        })
    },
    getFullDate (dateFormat, time, slash) {
      const nowtime = time ? new Date(time) : new Date();
      const now     = nowtime.toLocaleDateString('zh', { timeZone: 'Asia/Taipei' });
      // 取得個別值
      let year        = '';
      let month       = '';
      let date        = '';
      let usableMonth = '';
      let usableDate  = '';
      // 取得對應時間
      year  = now.indexOf('-') !== -1 ? now.split('-')[0] : now.split('/')[0];
      month = now.indexOf('-') !== -1 ? now.split('-')[1] : now.split('/')[1];
      date  = now.indexOf('-') !== -1 ? now.split('-')[2] : now.split('/')[2];
      // 修正時間格式
      usableMonth = parseInt(month) < 10 ? `0${month}` : month;
      usableDate  = parseInt(date) < 10  ? `0${date}`  : date;
      // 產出時間
      if (slash) {
          if (dateFormat === 'full') {
              if (slash === 'dash') {
                  return `${year}-${usableMonth}-${usableDate}`;
              }
              else {
                  return `${year}/${usableMonth}/${usableDate}`;
              }
          }
          else {
              if (slash === 'dash') {
                  return `${usableMonth}-${usableDate}`;
              }
              else {
                  return `${usableMonth}/${usableDate}`;
              }
          }
      }
      else {
          if (dateFormat === 'full') {
              return `${year}${usableMonth}${usableDate}`;
          }
          else {
              return `${usableMonth}${usableDate}`;
          }
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    exportToExcel() {
      const nowPage = localStorage.getItem('NowPage');
      const service = this.$route.params.service;
      let authName = '';
      if (service === 'FB') {
        authName = JSON.parse(nowPage).PageName.replace(/(^\s*)|(\s*$)/g, "");
      }
      else {
        authName = JSON.parse(nowPage).Provider.replace(/(^\s*)|(\s*$)/g, "");
      }
      const nowTime = this.getFullDate('full', null, false);
      const fileName = `${authName}_${this.deletedTag}_${service}_${nowTime}`;
      
      let sheetUser = [];
      for (let i = 0; i < this.TagUser.length; i += 1) {
        sheetUser.push({
          Phone: this.TagUser[i][1].Phone,
          Name: this.TagUser[i][1].Name,
          ID: this.TagUser[i][0]
        })
      }
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../../excel/Export2Excel');
        const tHeader = ['Phone', 'Name', 'ID'];  // 设置 Excel 的表格第一行的标题
        const filterVal = ['Phone', 'Name', 'ID'];  // tableData 里对象的属性
        const data = this.formatJson(filterVal, sheetUser);
        export_json_to_excel(tHeader, data, fileName);  //导出 Excel 文件名
      })
    },
    export2Excel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../../excel/Export2Excel');
        const tHeader = ['Phone'];  // 设置 Excel 的表格第一行的标题
        const filterVal = ['Phone'];  // tableData 里对象的属性
        const list = this.sheetData;  //把 data 里的 tableData 存到 list
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, 'sample');  //导出 Excel 文件名
      })
    },
    transformFile(e) {
      e.preventDefault();
      let file = e.target.files;
      if (file.length <= 0) { // 如果沒有檔名
        return;
      } 
      else if (!/\.(xls|xlsx)$/.test(file[0].name.toLowerCase())) {
        return;
      }
      let fileReader = new FileReader();
      if (typeof fileReader === 'undefined') {
        return
      }
      var vm = this;
      vm.progressBar = true;
      fileReader.onload = function(ev) {
        try {
          var data = ev.target.result,
          workbook = XLSX.read(data, { type: 'binary' }), // 以二进制流方式读取得到整份excel表格对象
          persons = []; // 存储获取到的数据
        } 
        catch (e) {
          return;
        }
        // 表格的表格范围，可用于判断表头是否数量是否正确
        var fromTo = '';
        // 遍历每张表读取
        for (var sheet in workbook.Sheets) {
          if (workbook.Sheets.hasOwnProperty(sheet)) {
            fromTo = workbook.Sheets[sheet]['!ref'];
            persons = persons.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
            break;
          }
        }
        if (persons.length <= 1000) {
          vm.sheetUsers = persons;
        }
        else {
        }
        vm.progressBar = false;
      }
      // 以二进制方式打开文件
      fileReader.readAsBinaryString(file[0]);
    },
    showList(row) {
      this.tagPage     = '0';
      this.showTagUser = true;
      this.TagUser     = [['12345', { Name: '載入中...', Phone: '載入中...' }]];
      this.getTagUser({ service: this.service, auth: this.auth, tagName: row[0] })
        .then((res) => {
          this.TagUser     = res.data.List;
          this.deletedTag  = row[0];
          this.refreshTagNum({ service: this.service, auth: this.auth, tag: row[0], count: this.TagUser.length });
        })
    },
    addUserTags() {
      this.batchDia = false;
      this.confirmDia = false;
      this.pageLoading = true;
      const phoneList = this.sheetUsers.map(el => el.Phone);
      this.createTags({ service: this.service, auth: this.auth, phone: phoneList, tag: this.tagName, bindServ: this.bindServ })
        .then(() => {
          this.sheetUsers = [];
          this.bindServ = [];
          this.pageLoading = false;
          this.showFlassMessage('已匯入名單', 1000);
        })
    },
    checkRemove(row) {
      this.userDetail.token = row[0];
      this.showDeleteDia = true;
    }
  },
}
</script>

<style scoped>

.blue_btn {
  background: rgba(48, 117, 229, 0.2);
  border: 1px solid rgba(48, 117, 229, 1);
  color: rgba(48, 117, 229, 1);
  transform: translateY(-3px);
  display: inline-block;
  padding: 2px 15px;
  font-size: 16px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 5px;
}
.blue_btn:hover {
  background: rgba(255, 28, 28, 0.2);
  border: 1px solid rgba(255, 28, 28, 1);
  color: rgba(255, 28, 28, 1);
  transform: translateY(-3px);
  display: inline-block;
  padding: 2px 15px;
  font-size: 16px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 5px;
}
.msg {
  margin: 0 auto;
  background-color: #fff;
  padding: 15px;
  border-radius: 5px;
  width: 89%;
  /* min-width: 750px; */
  max-width: 850px;
  box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
}
.work {
  font-size: 17px;
}

</style>